module.exports = __webpack_public_path__ + "images/137_2048.jpg";